module.exports = __webpack_public_path__ + "static/media/cribbar2.ba1bb83f.JPG";